var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "music"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17432",
    "data-name": "\\u9577\\u65B9\\u5F62 17432",
    width: 47,
    height: 47,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28480",
    "data-name": "\\u30D1\\u30B9 28480",
    d: "M37.288,28.736V5.147a2.17,2.17,0,0,0-2.616-2.1l-19.3,4.289a2.144,2.144,0,0,0-1.673,2.1V27.321a7.484,7.484,0,1,0,4.289,6.819,9.35,9.35,0,0,0,0-1.115V11.152L33,7.828v15.2a7.484,7.484,0,1,0,4.289,6.8,9.8,9.8,0,0,0,0-1.094Z",
    transform: "translate(0.894 1.745)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicBlack);
export default __webpack_public_path__ + "static/media/musicBlack.4ae458e5195fcdbe9e4aca7ac92ab982.svg";
export { ForwardRef as ReactComponent };